import { Flex, Grid } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import { TagsFilter, TagsFilter_Fragment } from "./TagsFilter";
import { ProductMenuGrid_Fragment, ProductGrid } from "./ProductMenuGrid";
import { b } from "@/b";
import { FragmentData } from "@gqlb/core";
import { useRouter } from "next/router";

export const FilteredProductMenuGrid_Fragment = b.fragment(
  "FilteredProductMenuGrid",
  "Menu",
  (b) => [
    b.__fragment(TagsFilter_Fragment),
    b.__fragment(ProductMenuGrid_Fragment),
  ]
);

export const FilteredProductMenuGrid: React.FC<{
  data: FragmentData<typeof FilteredProductMenuGrid_Fragment>;
}> = ({ data }) => {
  const router = useRouter();
  const tagFilter =
    router.query.tags
      ?.toString()
      ?.split(",")
      .filter((t) => t !== "") ?? [];
  const setTagFilter = useCallback(
    (tagIds: string[]) => {
      if (tagIds.length === 0) {
        const { tags, ...rest } = router.query;
        router.replace(
          {
            query: rest,
          },
          undefined,
          {
            scroll: false,
            shallow: true,
          }
        );
        return;
      }
      router.replace(
        {
          query: {
            ...router.query,
            tags: tagIds.join(","),
          },
        },
        undefined,
        {
          scroll: false,
          shallow: true,
        }
      );
    },
    [router]
  );

  return (
    <Grid
      w="full"
      templateColumns={{
        base: "1fr",
        lg: "auto 1fr",
      }}
      columnGap="8"
      rowGap="8"
    >
      <TagsFilter
        data={data}
        selectedTags={Array.from(tagFilter)}
        onClick={(tag) => {
          const newTags = new Set(tagFilter);
          if (tagFilter.includes(tag)) {
            newTags.delete(tag);
          } else {
            newTags.add(tag);
          }
          setTagFilter(Array.from(newTags));
        }}
        onClear={() => {
          setTagFilter([]);
        }}
      />
      <ProductGrid tagIdFilter={tagFilter} data={data} />
    </Grid>
  );
};
